export function isJson(str: string): boolean {
  try {
    const value = JSON.parse(str);
    return typeof value === 'object';
  } catch (error) {
    return false;
  }
}
